module.exports = __webpack_public_path__ + "img/allTimeTransactions.93916dda.svg";